import { useState } from 'react';
import { Modal } from '../Modal';
import { ActionButton, useActionLock } from '../ActionButton';

/**
 * Confirm step for "Cancel audit" (Audits hub + conduct page). Cancelled
 * audits are KEPT in SharePoint marked 'cancelled' and tasks raised during
 * them stay open (owner decisions 2026-10-15) — the copy says so.
 */
export function CancelAuditDialog({
  storeLabel,
  onConfirm,
  onClose,
}: {
  storeLabel: string;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}) {
  const lock = useActionLock();
  const busy = lock.busy;
  const [error, setError] = useState<string | null>(null);

  const confirm = async () => {
    setError(null);
    try {
      await onConfirm();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  };

  return (
    <Modal onClose={onClose} busy={busy}>
        <h2>Cancel this audit?</h2>
        <p>
          <strong>{storeLabel}</strong>
        </p>
        <ul>
          <li>The audit is closed and can’t be resumed or submitted.</li>
          <li>
            It stays on record marked <em>cancelled</em> and does not count
            as a completed audit for this store.
          </li>
          <li>Any tasks you created during it stay open and assigned.</li>
        </ul>
        <p className="muted">This can’t be undone.</p>
        {error && <p className="error">{error}</p>}
        <div className="modal-actions">
          <button type="button" className="btn" disabled={busy} onClick={onClose}>
            Keep audit
          </button>
          <ActionButton
            className="btn btn-danger"
            lock={lock}
            busyLabel="Cancelling…"
            onAction={confirm}
          >
            Cancel audit
          </ActionButton>
        </div>
    </Modal>
  );
}
